import React, { PureComponent } from 'react';
import connect from 'react-redux/es/connect/connect';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { loginUser, logoutUser } from '../../actions/authentication-actions';
import {
  setProjectsAdminUserList,
  setProjectsAdminProjects,
  setAdminSelectedUser,
  toggleAdminProjectsLoader,
} from '../../actions/projects-admin-action';
import MiniCADAPI from '../../lib/MiniCADAPI';
import { auth } from '../../lib/authentication';
import SubProjectService from '../../lib/services/sub-project-service';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import './ProjectsAdminCrud.css';
import MiniCADAPI_SEARCH from '../../lib/MiniCADAPI_SEARCH';
import { switchRefreshAdminProjects } from '../../actions/generic-globals.actions';
import { ProgressBar } from 'primereact/progressbar';
import { InputText } from 'primereact/inputtext';
import LZString from 'lz-string';

const dayjs = require('dayjs');

class UserDetailListComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectionDetails: '',
      showItemIndexInView: false,
      isCompactMode: false,
      isModalSelection: true,
      hideDialog: true,
      confirmCB: null,
      users: this.props.users,
      selectedUser: null,
      showLoadingBar: false,
      globalFilter: '',
      updateAllUsersDepartment: true,
      usersToUse: [],
      adTokenMissing: false,
    };

    this.formatProcessingEmail = this.formatProcessingEmail.bind(this);
    this.formatDate = this.formatDate.bind(this);
    this.reset = this.reset.bind(this);
  }

  componentDidMount = async () => {
    this.props.toggleAdminProjectsLoader(true);

    // STRY0177874: the admin button is now granted by email domain, but the AD
    // token still comes from the backend authorizer. If it withheld the token,
    // fail with a readable message instead of leaving the loader spinning.
    const adminTokens = this.props.resourcesTokens && this.props.resourcesTokens.users;
    if (!adminTokens || !adminTokens.adToken) {
      console.error('Admin panel: resourcesTokens.users.adToken is missing; cannot load the user list.');
      this.setState({ adTokenMissing: true });
      this.props.toggleAdminProjectsLoader(false);
      return;
    }

    let token = this.props.resourcesTokens.users.adToken;
    let tableToken = this.props.resourcesTokens.users.tableToken;
    let users;
    let usersResponse;

    if (this.state.updateAllUsersDepartment) {
      console.log('Updating users department info');
      const users = await MiniCADAPI.getAllUsersWithDepartments(tableToken);
      const usersToUpdate = users.filter((user) => user.department !== 'Cultec');

      // const updatePromises = usersToUpdate.map((user) => MiniCADAPI.setB2cUsersDepartment(token, user.userId));
      // await Promise.all(updatePromises);
      console.log('Department updated for all relevant users');
    }

    let restoredUsers;
    try {
      const usersStp1 = localStorage.getItem('users');
      const usersStp2 = LZString.decompress(usersStp1);
      const usersStp3 = JSON.parse(usersStp2);
      let usersStp4;
      if (typeof usersStp4 !== 'string') usersStp4 = JSON.parse(usersStp3);
      else usersStp4 = usersStp3;

      if (typeof usersStp4 !== 'string') {
        restoredUsers = usersStp4;
      } else {
        console.info('removing users from storage');
        localStorage.removeItem('users');
        console.info('Cannot decompress :: ', usersStp4.slice(0, 15) + (usersStp4.length > 15 ? '...' : ''));
      }
    } catch (e) {
      console.info(`null error corrected ${e.message}`);
    }

    for (let i = 0; i < 3; i++) {
      try {
        if (restoredUsers) {
          users = restoredUsers;
          this.setState({ showLoadingBar: true });
          MiniCADAPI.getCultecUsers(token).then((rsp) => {
            const objJSON = JSON.stringify(rsp);
            localStorage.removeItem('users');
            localStorage.setItem('users', LZString.compress(JSON.stringify(objJSON)));
            users = rsp;
            this.setState({ usersToUse: this.constructUsers(users) });
          });
        } else {
          this.setState({ showLoadingBar: true });
          users = await MiniCADAPI.getCultecUsers(token);
          const objJSON = JSON.stringify(users);
          localStorage.removeItem('users');
          localStorage.setItem('users', LZString.compress(JSON.stringify(objJSON)));
        }

        this.setState({ showLoadingBar: false });
        if (users) {
          break;
        }
      } catch (e) {
        let info = await auth.loadFromCache();
        await MiniCADAPI.setB2cUsersDepartment(info.resourcesTokens.users.adToken, info.accessToken.uniqueId);
        const b2cData = await MiniCADAPI.getB2CUser(
          info.resourcesTokens.users.adToken,
          info.accessToken.uniqueId
        );
        const userData = await MiniCADAPI.getUserRecord(
          info.user.id,
          info.resourcesTokens.users.tableToken
        );
        this.props.loginUser({
          ...info,
          b2cData: b2cData,
          county: userData.county,
          mailingList: userData.mailingList,
        });
        token = info.resourcesTokens.users.adToken;
      }
    }

    this.props.setProjectsAdminUserList(this.constructUsers(users));

    try {
      this.setState({ usersToUse: this.constructUsers(users) });
      this.setState({
        users: this.state.usersToUse,
      });
    } catch (e) {
      console.info(`cannot be updated`);
    }

    this.props.setProjectsAdminProjects([], {});
    this.props.toggleAdminProjectsLoader(false);
  };

  constructUsers(users) {
    return users
      .filter((user) => user.id !== this.props.user.id) // FILTERS USERS and removes ME - comment to debug
      .map((obj) => {
        obj['createdDateEPOCH'] = Date.parse(obj.createdDateTime);
        obj['createdDate'] = new Date(obj.createdDateTime);
        obj['email'] = obj.identities[0].issuerAssignedId;
        return obj;
      })
      .sort((a, b) => {
        return b.createdDate - a.createdDate;
      });
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.refreshAdminProjects !== prevProps.refreshAdminProjects) {
      this.getRecords(this.state.selectedUser.id).then((r) => {
        this.props.switchRefreshAdminProjects(false);
      });
    }
  }

  handleFilterByName = (e) => {
    this.setState({
      users: this.props.users.filter((user) => {
        return user.givenName && user.givenName.toLowerCase().includes(e.target.value.toLowerCase());
      }),
    });
  };

  fetchProjectsForUser = (userId) => {
    this.getRecords(userId).then((r) => {});
  };

  async getRecords(userId) {
    this.props.toggleAdminProjectsLoader(true);
    try {
      let iTokens = await auth.getSpecificUserReadTokens(
        this.props.idToken,
        this.props.user,
        this.props.accessToken,
        userId,
      );
      const config = {
        PartitionKey: userId,
        orderBy: { createdDate: 'desc' },
        top: 100,
        skip: 0,
      };

      let { value: projects, '@odata.count': projectsCount } = await MiniCADAPI_SEARCH.getSearchProjects(config);

      projectsCount = projectsCount - 100;
      const runFor = Math.round(projectsCount / 100);
      let counter = 0;

      for (let i = 0; i < runFor; i++) {
        counter = counter + 100;
        const srp = await MiniCADAPI_SEARCH.getSearchProjects({
          // PartitionKey: this.props.user.id,
          PartitionKey: userId,
          orderBy: { createdDate: 'desc' },
          top: 100,
          skip: counter,
        });
        projects = [...projects, ...srp.value];
      }

      const subProjects = await SubProjectService.loadAllUserSubProjects(
        userId,
        iTokens.subprojects.iTableToken,
        this.props,
      );

      // Stitch subprojects to projects
      for (const proj of projects) {
        let projectSubProjects = [];
        proj['id'] = proj.RowKey;
        proj['subProjects'] = [];
        proj['multiBeds'] = '';

        if (proj.processingStatus === 'failedDownload') {
          // required to fix rare instance where the value is failedDownload
          proj.processingStatus = 'failed';
        }

        if (proj.isMultiBedProject || proj.ismultibedProject) {
          projectSubProjects = subProjects.filter((subProjects) => {
            return subProjects.parentProjectId === proj.id;
          });
          if (
            projectSubProjects &&
            projectSubProjects.length > 0 &&
            proj.id === projectSubProjects[0].parentProjectId
          ) {
            proj['subProjects'] = projectSubProjects;
          }
        }
      }

      projects.forEach((proj) => {
        proj.translatedProjectType = this.props.content[this.props.lang][proj.projectType.toLowerCase()];
      });

      this.props.setProjectsAdminProjects(projects, iTokens);
    } catch (e) {
      console.error(`Error fetching project(s) ${e.message}`);
    }
    this.props.toggleAdminProjectsLoader(false);
  }

  closeDialog = () => {
    this.setState({ hideDialog: true });
  };

  setSelectionDetails = (val) => {
    const item = val;
    if (!item) {
      return;
    }
    const msg = `1 ${this.props.content[this.props.lang].itemSelected}:  ${val.givenName}`;
    this.props.setAdminSelectedUser(item);
    this.fetchProjectsForUser(item.id);
    this.setState({ selectionDetails: msg });
  };

  styledHeader(data) {
    return (
      <span
        style={{
          display: 'flex',
          alignItems: 'flex-end',
          marginRight: '5px',
        }}>
        <i className={`ms-Icon ms-Icon--${data.iconName}`} style={{ fontSize: '13px', marginRight: '5px' }} />{' '}
        {data.fieldName}
      </span>
    );
  }

  formatProcessingEmail(rowData) {
    const { identities } = rowData;
    return <span className={``}>{identities.length > 0 ? identities[0].issuerAssignedId : null}</span>;
  }

  formatDate(rowData) {
    const { createdDate } = rowData;
    return <span>{dayjs(createdDate).format('MM-DD-YYYY-hh:mm:ss-A')}</span>;
  }

  reset() {
    this.setState({
      selectedStatus: null,
      selectedType: null,
      globalFilter: '',
    });
    this.dt.reset();
  }

  render() {
    const { lang, content } = this.props;

    // ponytail: internal diagnostic, English only. Add a localization key if the
    // admin panel is ever opened to non-English users.
    if (this.state.adTokenMissing) {
      return (
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <p className="ms-fontSize-l ms-normalize">
                Admin data is unavailable for this account. Your sign-in did not return the directory
                access it needs. Please contact support.
              </p>
            </div>
          </div>
        </div>
      );
    }

    const emailFilter = (value, filter) => {
      if (filter.length >= 4 && value[0].issuerAssignedId) {
        return !!value[0].issuerAssignedId.includes(filter);
      }
      return false;
    };

    return (
      <div>
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row title-row">
            <div className="ms-Grid-col ms-sm12 ms-md10 ms-lg6">
              <p className="ms-fontSize-xl crud-title ms-fontColor-white ms-normalize">
                <Icon iconName="AccountManagement" className="ms-IconExample" /> {content[lang].userList}
              </p>
            </div>
          </div>
        </div>
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row ms-bgColor-neutralLight">
            <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg3 input-container">
              <InputText
                type="search"
                value={this.state.globalFilter}
                onChange={(e) => this.setState({ globalFilter: e.target.value })}
                placeholder="Global users Search"
                className={'global-search-1'}
              />
              {/*<TextField label="Filter by name:" onChange={this.handleFilterByName}/>*/}
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md3 ms-lg2 input-container">
              <p className={'selection-details'}>
                <b>{this.state.selectionDetails}</b>
              </p>
            </div>
          </div>
        </div>
        {this.state.showLoadingBar ? <ProgressBar mode="indeterminate" /> : null}
        <DataTable
          ref={(el) => (this.dtu = el)}
          globalFilter={this.state.globalFilter}
          emptyMessage="No users found."
          value={this.state.users}
          selection={this.state.selectedUser}
          selectionMode="single"
          onSelectionChange={(evt) => {
            this.setState({ selectedUser: evt.value });
            this.setSelectionDetails(evt.value);
          }}
          dataKey="id"
          paginator
          rows={10}
          currentPageReportTemplate="{first} / {last} of {totalRecords}"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
          //scrollable
          scrollHeight="400px"
          //resizableColumns
          columnResizeMode="fit"
          className="p-datatable-users"
          rowHover>
          <Column selectionMode="single" headerStyle={{ width: '3em' }} className={'forced_padding'} />
          <Column
            field="givenName"
            columnKey="givenName"
            header={this.styledHeader({
              iconName: 'ContactCard',
              fieldName: 'Given Name',
            })}
            headerStyle={{
              width: '100px',
            }}
            sortable
            filter
            filterMatchMode="contains"
            filterPlaceholder="by name"
          />
          <Column
            field="surname"
            columnKey="surname"
            header={this.styledHeader({
              iconName: 'ContactCard',
              fieldName: 'Surname',
            })}
            headerStyle={{
              width: '100px',
            }}
            sortable
            filter
            filterMatchMode="contains"
            filterPlaceholder="by surname"
          />
          <Column
            field="state"
            columnKey="state"
            header={this.styledHeader({
              iconName: 'POISolid',
              fieldName: 'State',
            })}
            headerStyle={{
              width: '100px',
            }}
            sortable
            filter
            filterPlaceholder="by state"
          />

          <Column
            field="email"
            header={this.styledHeader({
              iconName: 'POISolid',
              fieldName: 'Email',
            })}
            headerStyle={{
              width: '100px',
            }}
            sortable
            filterMatchMode="contains"
            filter
            filterPlaceholder="by email"
          />

          <Column
            field="companyName"
            columnKey="companyName"
            header={this.styledHeader({
              iconName: 'POISolid',
              fieldName: 'Company',
            })}
            headerStyle={{
              width: '100px',
            }}
            sortable
            filter
            filterMatchMode="contains"
            filterPlaceholder="by company"
          />
          <Column
            field="mobilePhone"
            columnKey="mobilePhone"
            header={this.styledHeader({
              iconName: 'POISolid',
              fieldName: 'Phone',
            })}
            headerStyle={{
              width: '100px',
            }}
            sortable
            filter
            filterPlaceholder="by phone"
          />

          <Column
            field="createdDate"
            columnKey="createdDate"
            header={this.styledHeader({
              iconName: 'ContactCard',
              fieldName: 'Creation Date',
            })}
            headerStyle={{
              width: '100px',
            }}
            body={this.formatDate}
            sortable
          />
        </DataTable>
        {this.state.showLoadingBar ? <ProgressBar mode="indeterminate" /> : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lang: state.localization.lang,
    user: state.authentication.user,
    users: state.projectsAdmin.users,
    content: state.localization.content,
    idToken: state.authentication.idToken,
    projects: state.projectsAdmin.projects,
    accessToken: state.authentication.accessToken,
    resourcesTokens: state.authentication.resourcesTokens,
    isProjectFromAnotherUsr: state.projectsAdmin.isProjectFromAnotherUsr,
    refreshAdminProjects: state.globals.refreshAdminProjects,
  };
};

const mapDispatchToProps = {
  loginUser,
  logoutUser,
  setProjectsAdminProjects,
  setAdminSelectedUser,
  setProjectsAdminUserList,
  toggleAdminProjectsLoader,
  switchRefreshAdminProjects,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserDetailListComponent);



// WEBPACK FOOTER //
// ./src/components/ProjectsAdminCrud/UserDetailListComponent.js